// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3SRiM","bigColWidth":"Table_bigColWidth__1f108","biggerColWidth":"Table_biggerColWidth__l-k4u","row":"Table_row__176Jc","col":"Table_col__3rA3-"};